import { render, staticRenderFns } from "./GroupAddModal.vue?vue&type=template&id=894066f4&"
import script from "./GroupAddModal.vue?vue&type=script&lang=js&"
export * from "./GroupAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroupAddModal.vue"
export default component.exports